import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedFacebookImportStep =
  () => import(/* webpackChunkName: "facebook-import-step.async" */ './facebook-import-step')
    .then(({ FacebookImportStepWithI18n }) => FacebookImportStepWithI18n);

export const FacebookImportStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.FACEBOOK_IMPORT,
  view: DelayedFacebookImportStep,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
    guards: {
      needsLoading: () => false,
      needsSaving: () => false,
    },
  },
};
